<p class="text-black text-end  my-6 cursor-pointer dark:text-gray-300">العربيه</p>